import React from 'react';
import './login.css'
import { signInWithGoogle } from '../../Firebase/Firebase';

//muestra el boton de login con gmail
export default function Login() {

  return (
      <div className="login-buttons">
        <button className="login-provider-button" onClick={signInWithGoogle}>
        <img src="https://img.icons8.com/ios-filled/50/000000/google-logo.png" alt="google icon"/>
        <span> Continua con Google</span>
       </button>
      </div>
  );
}